var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('storeList',{attrs:{"visible":_vm.visible,"data":_vm.checked},on:{"changeStore":_vm.handleChangeStore,"onClose":_vm.handleClose,"change":_vm.handleChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }